








import { FontManager } from '@/model/fontManager/fontManager';
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  components: {
  }
})
export default class WebfontRenderer extends Vue
{
    private get fontStyles() {
        let styles : Array<any> = [];
        const fontManager : FontManager = this.$store.getters.fontManager;
        for(var i = 0; i < fontManager.getFontNumber(); ++i)
        {
            var font = fontManager.getFontFamily(i);
            if(!font.isLocalFont) {
                let fontFamily = fontManager.getFontFamilyName(font.id);
                let fontWeight = font.weight != null ? font.weight.toString() : "normal";
                let style = {
                    "font-size" : "8px",
                    "font-family" : fontFamily,
                    "font-weight" : fontWeight
                };
                styles.push(style);
            }
        }
        return styles;
    }
}
